<script lang="ts" setup>
import { onMounted, ref, showErrorMsg, watch } from '#imports';
import { getCountryCodes } from '~/api/login';
import type { SelectOption } from '~/types/common';

defineOptions({
  inheritAttrs: false,
});
const countryCodeModel = defineModel('code', {
  type: String,
  default: '86',
});
const shortModel = defineModel('short', {
  type: String,
  default: 'CN',
});
const patternModel = defineModel('pattern', {
  type: String,
});
const props = defineProps({ label: { type: String, default: '' } });
const countryList = ref<SelectOption[]>([]);
const selectOpen = ref(false);
const inputRef = ref();

const handleDropdownVisibleChange = (open: boolean) => {
  selectOpen.value = open;
};

const handleSelectChange = (_: any, option: any) => {
  shortModel.value = option.value;
  countryCodeModel.value = option.label;
  patternModel.value = option.pattern;
  inputRef.value?.focus();
};

onMounted(() => {
  getCountryCodes()
    .then((res) => {
      countryList.value = res.map((item) => ({
        name: item.name,
        label: item.code,
        value: item.short,
        pattern: item.regular,
      }));
    })
    .catch((e) => {
      showErrorMsg(e);
    });
});
</script>

<template>
  <div
    class="relative"
    :class="{ 'field-has-value': $attrs.value, 'field-focused': selectOpen }"
  >
    <a-input v-bind="$attrs" ref="inputRef" class="placeholder-25">
      <template #prefix>
        <a-select
          v-model:value="shortModel"
          size="small"
          :open="selectOpen"
          :options="countryList"
          :bordered="false"
          :dropdown-match-select-width="false"
          :dropdown-align="{offset: [-12, 8]}"
          @dropdown-visible-change="handleDropdownVisibleChange"
          @change="handleSelectChange"
        >
          <template #option="{ name, label: codeLabel }">
            <div class="flex w-[135px] justify-between">
              <div>{{ name }}</div>
              <div>+{{ codeLabel }}</div>
            </div>
          </template>
          <template #suffixIcon>
            <img src="~/assets/image/icon/icon-arrow-down-12x12.svg" alt="arrow" />
          </template>
        </a-select>
      </template>
    </a-input>
    <span class="form-field-label">{{ props.label }}</span>
  </div>
</template>

<style scoped>
:deep(.ant-select-selector) {
  padding-left: 0 !important;
  border-left: 0 !important;
}
:deep(.ant-select-selector .ant-select-selection-item) {
  @apply text-sm font-bold text-subtitle;
}
:deep(.ant-select-selector .ant-select-selection-item::before) {
  content: '+';
}
</style>
